import { toast } from "@shared/ui/use-toast";

export const downloadFile = (blob: Blob, filename = "template.pdf") => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const openPdfInNewTab = (blob: Blob) => {
  const fileURL = window.URL.createObjectURL(blob);
  window.open(fileURL, "_blank", "fullscreen=yes");
};

export const printPDFBlob = (blob: Blob, timeout = 1000) => {
  const blobUrl = URL.createObjectURL(blob);
  const printWindow = window.open(blobUrl, "_blank");

  const printTimeout = setTimeout(() => {
    if (printWindow) {
      printWindow.print();
      URL.revokeObjectURL(blobUrl);
    }
  }, timeout);

  if (!printWindow) {
    alert("Please allow popups for printing");
    URL.revokeObjectURL(blobUrl);
  }
};

// @shared/utils/downloadUtils.ts

export interface CSVDownloadOptions {
  filename?: string;
  addTimestamp?: boolean;
  timestampFormat?: "date" | "datetime" | "timestamp";
}

/**
 * Downloads a CSV blob as a file
 * @param blob - The CSV blob to download
 * @param filename - The base filename (without extension)
 * @param options - Download configuration options
 */
export const downloadCSV = (
  blob: Blob,
  filename: string = "export",
  options: Omit<CSVDownloadOptions, "filename"> = {}
) => {
  const { addTimestamp = true, timestampFormat = "date" } = options;

  // Ensure filename has .csv extension
  let finalFilename = filename.endsWith(".csv") ? filename : `${filename}.csv`;

  // Add timestamp if requested
  if (addTimestamp) {
    const now = new Date();
    let timestamp = "";

    switch (timestampFormat) {
      case "date":
        timestamp = now.toISOString().split("T")[0]; // YYYY-MM-DD
        break;
      case "datetime":
        timestamp = now.toISOString().replace(/[:.]/g, "-").slice(0, -5); // YYYY-MM-DDTHH-MM-SS
        break;
      case "timestamp":
        timestamp = now.getTime().toString(); // Unix timestamp
        break;
    }

    // Insert timestamp before .csv extension
    finalFilename = finalFilename.replace(".csv", `_${timestamp}.csv`);
  }

  // Create download link
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = finalFilename;

  // Trigger download
  document.body.appendChild(link);
  link.click();

  // Cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const downloadFileByUrl = (url: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = ""; // This forces download
  link.target = "_blank"; // Opens in new tab after download

  // Trigger the download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const viewFileByUrl = (url: string) => {
  const fileExtension = url.split(".").pop()?.toLowerCase();
  const viewableInBrowser = ["pdf", "png", "jpg", "jpeg", "txt", "mp4"];
  if (fileExtension && viewableInBrowser.includes(fileExtension)) {
    window.open(url, "_blank");
  } else {
    // Use Google Docs Viewer for non-browser viewable files
    const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
      url
    )}&embedded=true`;
    window.open(viewerUrl, "_blank");
  }
};
export const navigateToMap = (lat: any, lng: any) => {
  console.log("Latitude:", lat, "Longitude:", lng);
  if (lat == null || lng == null || lat === "" || lng === "") {
    toast({
      title: "Location Unavailable",
      description: "Latitude or longitude is missing. Unable to open map.",
      variant: "destructive",
    });
    return;
  }

  const url = `https://www.google.com/maps?q=${lat},${lng}`;
  window.open(url, "_blank");
};
